import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../config";

function UpdateProfilePopup() {
  const [showPopup, setShowPopup] = useState(false);
  const [email, setEmail] = useState(localStorage.getItem("email"));
  const [phone_no, setPhone] = useState("");
  const [errors, setErrors] = useState({});
  const [formLoading, setFormLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const validateEmail = (email) => /^\S+@\S+\.\S+$/.test(email);
  const validatePhone = (phone) => /^[6-9]\d{9}$/.test(phone);

  useEffect(() => {
    if (
      localStorage.getItem("userId") == 876 &&
      !localStorage.getItem("phone_no")
    ) {
      setShowPopup(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setMessage("");
    setErrorMessage("");

    if (!validateEmail(email)) {
      setErrors({ email: "Please enter a valid email address." });
      return;
    }
    if (!validatePhone(phone_no)) {
      setErrors({ phone_no: "Please enter a valid phone no." });
      return;
    }

    setFormLoading(true);
    try {
      await axios.patch(
        `${API_URL}user/update`,
        {
          email,
          phone: phone_no,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      // Mark as subscribed
      localStorage.setItem("phone_no", phone_no);
       setMessage("Updated successful!");
      setTimeout(() => {
        setShowPopup(false);
      }, 2000);
      
     
    } catch (error) {
      console.error(error);
      setErrorMessage(
        error?.response?.data?.message ||
          "Subscription failed. Please try again."
      );
    } finally {
      setFormLoading(false);
    }
  };

  if (!showPopup) return null;

  return (
    <div className="newsletter-popup-overlay">
      <div className="newsletter-popup-box">
        {/* Close button */}

        <h2 className="newsletter-popup-title">Contact Information</h2>
        <p className="newsletter-popup-desc">
          To continue with your order, please update your details first.
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            className={`newsletter-popup-input ${
              errors.email ? "invalid-input" : ""
            }`}
            placeholder="Enter your email address"
            value={email}
            disabled
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="phone"
            className={`newsletter-popup-input ${
              errors.phone_no ? "invalid-input" : ""
            }`}
            placeholder="Enter your phone number"
            value={phone_no}
            onChange={(e) => setPhone(e.target.value)}
            required
          />

          <div className="newsletter-popup-button-group">
            <button
              type="submit"
              className="newsletter-popup-button-primary"
              disabled={formLoading}
            >
              {formLoading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>

        {errors.email && <div className="text-danger mt-2">{errors.email}</div>}
        {errors.phone_no && (
          <div className="text-danger mt-2">{errors.phone_no}</div>
        )}
        {message && <div className="text-success mt-2">{message}</div>}
        {errorMessage && <div className="text-danger mt-2">{errorMessage}</div>}
      </div>
    </div>
  );
}

export default UpdateProfilePopup;
